import { useQuery } from '@tanstack/react-query';

import { API_MAX_LIMIT } from '@/constants';
import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { NestedNullable } from '@/types/types';

import { AudienceChannelSourceFilters, AudienceChannelSourceType } from '../types';

import { channelsQueryKeys } from './query-keys';

export async function getAudienceChannelSources(
  params?: NestedNullable<AudienceChannelSourceFilters>
): Promise<AudienceChannelSourceType[]> {
  return mediaManagerClient
    .get('/api/v1/audience_channel_sources', {
      params: (() => {
        const queryParams: Record<string, unknown> = {};

        if (params?.idIn && params.idIn.length > 0) {
          queryParams['id__in'] = params.idIn.join(',');
        }
        if (params?.includeIds && params.includeIds.length > 0) {
          queryParams['include_ids'] = params.includeIds.join(',');
        }
        if (params?.scopeIn) {
          queryParams['scope__in'] = params.scopeIn;
        }
        if (params?.mediaTypeIn) {
          queryParams['media_type__in'] = params.mediaTypeIn;
        }
        if (params?.providerIn && params.providerIn.length > 0) {
          queryParams['provider__in'] = params.providerIn.join(',');
        }
        if (params?.countryIn) {
          queryParams['country__in'] = params.countryIn;
        }
        if (params?.regionIn) {
          queryParams['region__in'] = params.regionIn;
        }
        if (typeof params?.name === 'string' && params.name.trim() !== '') {
          queryParams['search'] = params.name;
        }

        queryParams['limit'] = params?.limit ?? API_MAX_LIMIT;

        return queryParams;
      })(),
    })
    .then(({ data }) => data);
}

type QueryFnType = typeof getAudienceChannelSources;

interface UseSegmentsParams {
  config?: QueryConfig<QueryFnType>;
  params?: NestedNullable<AudienceChannelSourceFilters>;
}

export function useAudienceChannelSources({ config, params }: UseSegmentsParams = {}) {
  return useQuery({
    ...config,
    queryKey: channelsQueryKeys.audienceChannelSources(params),
    queryFn: () => getAudienceChannelSources(params),
  });
}
